import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 注册功能
 * @author Spark
 */
import { mapGetters } from 'vuex';
import api from 'api/login';
import SecurityCode from '~/module/securityCode';
import { GET_SCREEN, GET_PLUS_SDK } from '$getters';
export default {
  name: 'page-regist',
  data: function data() {
    return {
      url: 'https://www.dayaotex.com/gateway-manage/dayaotex-server-sms/megCode/validateCode',
      imgCode: '',
      loading: false,
      showPassword: false,
      userinfo: {
        mobile: null,
        password: null,
        msgCode: null
      },
      valid: {
        checked: false,
        mobile: true,
        password: true,
        msgCode: true
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    screen: GET_SCREEN,
    plusSdk: GET_PLUS_SDK
  })), {}, {
    params: function params() {
      return this.$route.params;
    },
    validation: function validation() {
      // return this.valid.checked && this.valid.mobile && this.valid.password && this.valid.msgCode
      return this.valid.checked && !this.isEmpty(this.userinfo.mobile) && !this.isEmpty(this.userinfo.password) && !this.isEmpty(this.userinfo.msgCode);
    }
  }),
  watch: {
    'userinfo.mobile': function userinfoMobile(val) {
      this.validMobile();
    },
    'userinfo.password': function userinfoPassword(val) {
      this.validPassword();
    },
    'userinfo.msgCode': function userinfoMsgCode(val) {
      this.validMsgCode();
    }
  },
  methods: {
    replace: function replace() {
      var num = Math.ceil(Math.random() * 10); // 生成一个随机数（防止缓存）

      this.url = 'https://www.dayaotex.com/gateway-manage/dayaotex-server-sms/megCode/validateCode?' + num;
    },
    doRegist: function doRegist() {
      var vm = this;
      var valid = vm.validForm();

      if (valid) {
        vm.loading = true;
        api.register({
          mobile: vm.userinfo.mobile,
          password: vm.userinfo.password,
          repeatPassword: vm.userinfo.password,
          msgCode: vm.userinfo.msgCode
        }).then(function (res) {
          if (res.type === 'ERROR') {
            vm.$toast.error(res.message);
          } else {
            if (vm.params && vm.params['to']) {
              vm.$router.replace(vm.params.to);
            } else {
              vm.$router.replace('/home');
            }
          }

          vm.loading = false;
        }).catch(function () {
          vm.loading = false;
        });
      }
    },
    validForm: function validForm() {
      var message = '';

      if (this.validMobile() != null) {
        message += this.validMobile();
      } else if (this.validMsgCode()) {
        message = this.validMsgCode();
      } else if (this.validPassword()) {
        message = this.validPassword();
      } else if (!this.valid.checked) {
        message = '请阅读并同意平台协议';
      }

      if (message.length > 0) {
        this.$toast(message);
      }

      return message.length === 0;
    },
    validMobile: function validMobile() {
      var mobile = this.userinfo.mobile;
      var message = null;

      if (mobile == null) {
        message = '请填写手机号码';
      } else if (!/^1[0-9]{10}$/.test(mobile)) {
        message = '手机号码格式错误';
      }

      this.valid.mobile = message == null;
      return message;
    },
    validPassword: function validPassword() {
      var password = this.userinfo.password; // eslint-disable-next-line

      var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@!%*#?&\.,\/'\[\]\-+_=]){0,1}[A-Za-z\d$@!%*#?&\.,\/'\[\]\-+_=]{8,18}$/;
      var message = null;

      if (password == null) {
        message = '请填写密码';
      } else if (!reg.test(password)) {
        message = '密码不符合规则';
      }

      this.valid.password = message == null;
      return message;
    },
    validMsgCode: function validMsgCode() {
      var message = null;

      if (this.userinfo.msgCode == null || this.userinfo.msgCode === '') {
        message = '请输入验证码';
      }

      this.valid.msgCode = message == null;
      return message;
    },
    isEmpty: function isEmpty(val) {
      return val == null || val.length === 0;
    }
  },
  mounted: function mounted() {// let vm = this
    // vm.SET_BACK_BUTTON_EVENT(null)
  },
  components: {
    'security-code': SecurityCode
  }
};